import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTooltip,
    {
      attrs: { bottom: "", "content-class": "engine-tooltip" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "span",
                _vm._g(_vm._b({}, "span", attrs, false), on),
                [
                  _c(
                    VBtn,
                    {
                      class: [
                        "refresh-button",
                        `${_vm.hasUnsavedKpiResults ? "unsaved-kpis" : ""}`,
                        `${_vm.hideText ? "" : "with-text"}`,
                      ],
                      attrs: {
                        depressed: "",
                        loading: _vm.recalculatingAll,
                        disabled: !_vm.canRecalculateAll,
                        "data-dd-action-name": "Recalculate all",
                      },
                      on: { click: _vm.runEngineForAllScenarios },
                    },
                    [
                      !_vm.hideText
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("actions.recalculateAll"))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("cog-play-icon"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", [
        _vm._v(_vm._s(_vm.$t("gridView.tooltips.strategicOptimiser"))),
      ]),
      _vm._v(" "),
      _vm.recalculateAllButtonBlockedMsg
        ? [
            _c(VDivider, { staticClass: "my-2", attrs: { dark: "" } }),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.recalculateAllButtonBlockedMsg))]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }